module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.222ff700.svg";